export enum LanguagesCode {
    English = 'en',
    Spanish = 'es',
}

export enum Language {
    EN = 'en',
    ES = 'es',
}

export enum CountryCodes {
    UK = 'GB',
    SPAIN = 'ES',
}

export const LanguagesCodes = Object.values(LanguagesCode);

export const FALLBACK_LNG = LanguagesCode.English;

export const LANGUAGES_IMPORT_MAP = {
    [LanguagesCode.Spanish]: () => import('./locales/es.json'),
    [LanguagesCode.English]: () => import('./locales/en.json'),
};
